import { HttpsAgent } from "agentkeepalive"
import axios, { AxiosRequestConfig } from "axios"

import axiosRetry, { IAxiosRetryConfig } from "axios-retry"

import { getCookie, handleLogout } from "../utils/utils"

// Optional: only use HttpsAgent in Node environment
export interface commonAxiosResponse<T = any> {
  success: boolean
  message?: string
  data?: T
}
const isBrowser = typeof window !== "undefined"

export const defaultHttpsAgent = new HttpsAgent({ keepAlive: true })

export const defaultTimeout = 40000

export const defaultConfig: AxiosRequestConfig = {
  timeout: defaultTimeout,

  ...(isBrowser ? {} : { httpsAgent: defaultHttpsAgent }), // avoid issues in browser

  headers: {
    app: "Gunsens Admin Panel",
  },
}
console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL)
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "",

  ...defaultConfig,
})

// Retry failed requests (e.g. network errors, 5xx)

axiosRetry(apiClient, {
  retries: 3,

  retryDelay: axiosRetry.exponentialDelay,

  retryCondition: (error: any) => {
    // Retry only on network errors or 5xx

    return axiosRetry.isNetworkOrIdempotentRequestError(error) || error.response?.status >= 500
  },
} as IAxiosRetryConfig)

// Optional auth token handling

apiClient.interceptors.request.use((config) => {
  const token = getCookie("authToken")

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // ⚠️ Clear token cookie (only works for non-HttpOnly cookies)
      handleLogout()
    }

    return Promise.reject(err)
  },
)

export default apiClient
